import { useOutletContext } from 'react-router-dom'
import { TabelaHorarios } from 'service/api'

export function useTabelaHorariosOutletContext() {
    return useOutletContext<{ data: TabelaHorarios[] }>()
}
